// import { IDefinitionLocator } from "flux-diagram-composer";
import { EntityModel } from "./entity.mdl";
import { DefinitionLocator } from "../../shape/definition/definition-locator.svc";


export class EntityHelper {
    public static getShapeDefForContext( entity: EntityModel, defLocator: DefinitionLocator, context: string = '*', modelPreferredDefId?: any ): { id: string , version: number} {
        const shapeDef = entity.getShapeDefIdForContext( context, modelPreferredDefId );
        if ( !shapeDef ) {
            return shapeDef;
        }
        const { id: defId, version: defVersion } = shapeDef;
        const latestVaerion = defLocator.getDefVersion( defId );
        if ( latestVaerion > defVersion ) {
            return { id: defId, version: latestVaerion };
        }
        return shapeDef;
    }
}